/* eslint-disable no-case-declarations */
import { combineReducers } from 'redux';
import {
  FETCH_SIGNALS_FAILURE,
  FETCH_SIGNALS_REQUEST,
  FETCH_SIGNALS_SUCCESS,
} from '../../../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_SIGNALS_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_SIGNALS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_SIGNALS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

const signalsList = combineReducers({
  list,
});

export default signalsList;
